import React, {useState} from "react";
import {messageTypes, sendStatus} from "./ChatConstants";
import {useTranslation} from "react-i18next";
import styles from "./UINotiNewMessage.module.scss";
import profil from "./images/UIChatRoom-profil2.png";
import close from "./images/close.svg";
import {getUrlHttp} from "src/service/util.service";

const UINotiNewMessage = (props: any) => {
  let membersDetail;
  let profile;
  let username;
  const [bottomStyle, setBottomStyle]: any = useState(64);
  const status: any = props.notiType;
  const { t } = useTranslation();
  if (status !== sendStatus.Reply) {
    membersDetail = props.tempMember?.filter((item: any) => {
      return item?.userId?.indexOf(props.userId) !== -1;
    });
    if (membersDetail?.length > 0) {
      profile = membersDetail[0]?.user?.profile || profil;
      username = membersDetail[0]?.user?.username;
    }
  }

  if (
    // props.messageType === messageTypes.CenterFlie ||
    props.messageType === messageTypes.JoinGroup ||
    props.messageType === messageTypes.LeaveGroup ||
    props.messageType === messageTypes.Invited
  )
    return;

  // useEffect(() => {
  //   if (props.isPageActive?.isOpen) {
  //     if (props.isPageActive?.type === "record") setBottomStyle(204);
  //     else setBottomStyle(314);
  //   } else {
  //     setBottomStyle(64);
  //   }
  //   // return () => {
  //   //   setBottomStyle(64);
  //   // };
  // }, [props.isPageActive]);

  return (
    <div
      className={props?.isQuickChat ? styles.notiNewMessage_quick_chat : styles.notiNewMessage}
      style={{
        bottom: "-16px",
        position: "absolute",
        marginBottom: "env(safe-area-inset-bottom)",
        width: "100%"
      }}
    >
      <div className={styles.groupNoti}>
        <div
          className={styles.profileImgNoti}
          onClick={
            props.isReply
              ? undefined
              : () => props.handleClick(sendStatus.Update)
          }
        >
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "#b8b8b8",
              backgroundPosition: "0",
              backgroundImage: `url(${
                status === sendStatus.Reply ? getUrlHttp(props.userProfile) : getUrlHttp(profile)
              })`,
              backgroundSize: "cover",
            }}
          ></div>
        </div>
        <div
          className={styles.messageNoti}
          style={{
            height: "100%",
            width: "calc(100% - 100px)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "1rem",
            margin: "auto",
          }}
          onClick={
            props.isReply
              ? undefined
              : () => props.handleClick(sendStatus.Update)
          }
        >
          {username || props.username} :{" "}
          {props.messageType === messageTypes.Text && props.messageText}
          {props.messageType === messageTypes.Link && props.messageText}
          {props.messageType === messageTypes.Image && t("send a photo.")}
          {props.messageType === messageTypes.Sound && t("send a voice message")+"."}
          {props.messageType === messageTypes.Video && t("send a video")+"."}
          {props.messageType === messageTypes.Sticker && t("send a sticker")+"."}
          {props.messageType === messageTypes.CenterFlie && t("shared a file")+"."}
          {props.messageType === messageTypes.MeetingRecord && t("send a meeting recorded")+"."}
        </div>
        <div
          className={styles.btnColseNoti}
          onClick={() => props.handleCloseNoti()}
        >
          <i>
            <img src={close} width="15px" height="15px" />
          </i>
        </div>
      </div>
    </div>
  );
};
//@ts-ignore
export default React.memo(UINotiNewMessage);
